document.querySelectorAll('.Megamenu_common_list_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    var swiperMain = new Swiper(el, {
        loop: false,
        grabCursor: true,
        spaceBetween: 28,
        slidesPerGroup: 1,
        slidesPerView: 2,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        breakpoints: {
            0: {
                slidesPerView: "auto",
                spaceBetween: 14
            },
            750: {
                slidesPerView: 2,
                spaceBetween: 28
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
  }
});